import React from "react";

import Neustarten from "../components/cover/animations/neustarten";
import background from '@cover/neustarten/background-1.jpg';
import backgroundSm from '@cover/neustarten/background-1-sm.jpg';
import background2 from '@cover/neustarten/background-2.png';
import background2Sm from '@cover/neustarten/background-2-sm.png';

export const meta = {
	category: "start",
	slug: "neu",
	id: "Neustarten",
	excerpt: {
		before: "Zurück zu einem starken Miteinander – die Pandemie hat uns vor Augen geführt, dass Werte, die unsere Demokratie prägen, in hohem Maße verletzlich sind."
	},
	name: "neustarten",
	title: "Zurück zu einem starken Miteinander",
	animation: Neustarten,
	cover: {
		background: {
			lg: background,
			sm: backgroundSm
		},
		layers: [
			{
				src: {
					lg: background2,
					sm: background2Sm
				},
				zIndex: 666,
			}
		],
		alt: "Eine Spirale windet sich inmitten von Ladebalken nach oben und signalisiert: Gleich geht es los!"
	}
}

const NeustartArticle = () => {
	return (
		<div>
			<p className="articleParagraph">
				Die Pandemie hat uns vor Augen
				geführt, dass Werte, die unsere Demokratie
				prägen, in hohem Maße verletzlich sind. Das
				haben nicht nur die Querdenker-Demonstrationen
				gezeigt, sondern auch jene, die
				ihre Profitgier über das Wohl aller stellten.
				Corona hat Fragen aufgeworfen, auf die wir
				dringend Antworten finden müssen: Wie
				gehen wir mit der zunehmenden Spaltung
				der Gesellschaft um? Und wie können wir
				das Vertrauen in die Demokratie stärken?

			</p>
			<p className="articleParagraph">
				Kinder, die während der Pandemie
				geboren wurden und in Zukunft geboren
				werden, lernen die Welt, in der wir aufgewachsen
				sind, in der Form nicht mehr kennen.
				Sie werden sie, anders als viele von
				uns, deshalb auch nicht vermissen. Aber
				auch sie werden ihr Leben und Wirken an
				demokratischen Werten orientieren. Und
				sich damit für eine Gesellschaft engagieren,
				die für Vielfalt und Meinungsfreiheit steht.
				Das ist eine Hoffnung, keine Selbstverständlichkeit.
				In den vergangenen Monaten
				haben wir erfahren müssen, dass Menschen,
				die ihre Stimme erheben, auch in
				der sicher geglaubten Europäischen Union
				um ihr Leben fürchten müssen. Das können,
				das dürfen wir nicht zulassen.
			</p>
			<p className="articleParagraph">
				Europa muss weiterhin ein Vorbild für
				Demokratie und den damit verbundenen
				Wertekodex sein. Wir, als Baden-Württemberg
				Stiftung, tun viel dafür, um Grenzen
				zu überwinden und Solidarität zu leben.
				Unsere Projekte und Programme aus den
				drei Bereichen Forschung, Bildung sowie
				Gesellschaft und Kultur sind darauf angelegt,
				Brücken zu bauen und nachhaltige
				Strukturen in Baden-Württemberg zu etablieren.
				Wir stiften Zukunft, das ist unser
				Credo und die Maxime unseres Handelns.
			</p>
			<p className="articleParagraph">
				„STOP. START. WEITER. Zurück auf
				Los!“ — wenn man das Leitmotiv unseres 
				Jahresberichts auf unser
				Engagement überträgt, so konnten wir
				beispielsweise mit zwei Projekten die
				Lebenssituation mancher Menschen positiv
				beeinflussen und die Verbreitung von
				Corona punktuell sogar <b>stoppen</b>. Mit dem
				Klangspektrum ist es uns schnell und
				unbürokratisch gelungen, 1.000 Musikschaffende
				finanziell zu unterstützen und
				damit ihre Existenzsorgen zu verringern.
				Und bereits im Juli 2020 haben wir mit dem
				CoVLAB eine mobile Corona-Teststation in
				Betrieb genommen, die früh Klarheit über
				die Infektionslage gab.
			</p>
			<p className="articleParagraph">
				Im Januar 2021 <b>startete</b> die Klimaschutzstiftung.
				Sie unterstützt die Landesverwaltung
				auf ihrem Weg, bis spätestens
				2030 klimaneutral zu werden. Die Unterstiftung
				fungiert dabei unter anderem als Drehscheibe
				für die Kompensation der aktuell
				noch unvermeidbaren CO₂-Emissionen für
				Kommunen, Unternehmen sowie Bürgerinnen
				und Bürger.
			</p>
			<p className="articleParagraph">
				Seit mehr als 20 Jahren fördern wir
				erfolgreich Programme, die Innovation,
				Bildung und Zusammenhalt im Land stärken.
				Und natürlich machen wir damit auch
				künftig <b>weiter</b>. Mit COACHING4FUTURE sorgen
				wir dafür, dass sich junge Menschen für
				naturwissenschaftlich-technische Berufe
				begeistern. Bei Talent im Land unterstützen
				wir Jugendiche und setzen uns so für mehr
				Bildungsgerechtigkeit ein. Und mit Vielfalt
				gefällt! stärken wir seit mehr als zehn Jahren
				das Miteinander.
			</p>
			<p className="articleParagraph">
				Noch sind die Folgen der Pandemie
				nicht abzusehen. Und aus der Vergangenheit
				Lösungen für die Zukunft zu entwickeln,
				dafür ist es noch zu früh. Aber wir
				können uns auf einen für die demokratische
				Gemeinschaft grundlegenden Wert
				berufen: Solidarität. Sie ist eine wesentliche
				Kraft, füreinander einzustehen und sich
				gegenseitig zu unterstützen. Nur wenn wir
				gemeinsam die Herausforderungen dieser
				ungewissen Zukunft annehmen, können wir
				sie bewältigen und als Gesellschaft neustarten.
				Nach dem Motto: Zurück auf Los!
				Zurück zu einem starken Miteinander!
			</p>
		</div>
	)
};

export default NeustartArticle;